import axios, { InternalAxiosRequestConfig } from "axios";
// import dotenv from "dotenv"

// dotenv.config();
export const BASE_URL = "https://api.alphatechrubber.sa/api/mobile-api";
export const IMAGE_URL = "https://api.alphatechrubber.sa/api/public/"

// export const BASE_URL = "http://localhost:4002/api/mobile-api";
// export const IMAGE_URL = "http://localhost:4002/api/public/"
// export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const NEXT_PUBLIC_TRANSLATE_KEY = 'AIzaSyD4rcn8bz9Nz8eqWlOJ-BjBMFau52NAtgE'

export const apiClient = axios.create({
  baseURL: BASE_URL,
});
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear user data and token
      localStorage.removeItem("userToken");
      localStorage.removeItem("user");

      // Redirect to login page ONLY if not already there to prevent refresh loop
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

apiClient.interceptors.request.use(
  function (config) {
    config.headers["Authorization"] = `Bearer ${localStorage.getItem("userToken")}`;
    config.headers["Content-Type"] = "application/json";

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default apiClient;
